import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lib/lodash'

import Table from "UI/Table"
import NavigationSelect from "UI/NavigationSelect"
import PopupForm from "UI/PopupForm"

import ImportCSV from "Features/ImportCSV"

import APIAuth from "Pages/API/Auth"
import SolidfireCapacityReport from "Pages/Solidfire/Capacity"
import AssetNameGenerator from 'Pages/AssetNameGenerator'

import IntegrationStatusDataProtectionReport from "Pages/Integrations/Status/DataProtection";
import VMIntegrationCoverage from "Pages/Integrations/Coverage/VM";
import ManagedServiceIntegrationCoverage from "Pages/Integrations/Coverage/ManagedService";
import OnPremiseCoverage from "Pages/Integrations/Coverage/OnPremise";
import LogicmonitorAssets from 'Pages/Integrations/LogicmonitorAssets'

// ASSETS
import VcenterAssetReport from "Pages/Assets/Vcenter";
import CommvaultAssetReport from "Pages/Assets/Commvault";
import CloudCoreConfigurationReport from "Pages/Assets/CloudCore/Configuration";
import CloudCoreCapacityReport from "Pages/Assets/CloudCore/Capacity";
import CloudCoreSoftwareReport from "Pages/Assets/CloudCore/Software";
import CloudCoreSoftwareApplicationsReport from "Pages/Assets/CloudCore/Software/Applications";
import CloudCoreSoftwareOperatingSystemsReport from "Pages/Assets/CloudCore/Software/OperatingSystems";
import CloudCoreSoftwareTerminalServersReport from "Pages/Assets/CloudCore/Software/TerminalServers";
import CloudCoreSoftwareDatacentersReport from "Pages/Assets/CloudCore/Software/Datacenters";
import CloudCoreConsumptionReport from "Pages/Assets/CloudCore/Consumption";
import CloudCoreComplianceReport from "Pages/Assets/CloudCore/Compliance";
import DataProtectionConsumptionReport from "Pages/Assets/CloudCore/Consumption/DataProtection";
import VmSplaReport from "Pages/Assets/CloudCore/SPLA";
import VmSplaEditor from "Pages/Assets/CloudCore/SPLA/Editor";
import vCentersTable from 'Pages/Assets/Vcenter/AssetsIndex';
import VulnerabilityGlobe from 'Pages/Vulnerabilities/Globe';

// System
import MonitoringTypes from '../pages/System/MonitoringTypes'
import ImportConfigurations from 'Pages/System/ImportConfigurations';

// Components
import AccessAssetsStatus from 'Components/AccessAssets/Status'
import VDCConsumptionReport from 'Components/VDC/Consumption'
import CloudianCapacityReport from 'Components/Cloudian/Capacity'
import NebulonCapacityReport from 'Components/Nebulon/Capacity'
import SystemsSummary from 'Components/Systems/Summary'
import PageBreadcrumbs from 'Components/PageBreadcrumbs'
import PrimaryMenu from 'Components/PrimaryMenu'
import AssetTypesTable from 'Components/AssetTypes'
import PhysicalAssetsTable from 'Components/PhysicalAssets'
import IPAssetVulnerabilitiesTable from 'Components/IPAssets/Vulnerabilities'
import IPAssetExternalTable from 'Components/IPAssets/External'
import IPAssetCertsTable from 'Components/IPAssets/Certs'
import SitesTable from 'Components/Sites'
import SPLAScopeReport from "Components/SPLA/Scope"
import EnrollDevice from './Demo/EnrollDevice'

const initComponent = (selector, component) => {
  _.each(document.querySelectorAll(selector), (element) => {
    let data = {}
    if (typeof element.dataset.props !== 'undefined') {
      data = JSON.parse(element.dataset.props)
  }
    const reactComponent = React.createElement(component, data)
    ReactDOM.render(reactComponent, element)
  })
}

window.addEventListener('load', () => {
  initComponent('.js-react-PrimaryMenu', PrimaryMenu)
  initComponent('.js-react-EnrollDevice', EnrollDevice)
  initComponent('.js-react-PageBreadcrumbs', PageBreadcrumbs)
  initComponent('.js-react-AssetNameGenerator', AssetNameGenerator)
  initComponent('.js-react-IntegrationStatusDataProtectionReport', IntegrationStatusDataProtectionReport)
  initComponent('.js-react-VMIntegrationCoverage', VMIntegrationCoverage)
  initComponent('.js-react-ManagedServiceIntegrationCoverage', ManagedServiceIntegrationCoverage)
  initComponent('.js-react-VcenterAssetReport', VcenterAssetReport)
  initComponent('.js-react-CommvaultAssetReport', CommvaultAssetReport)
  initComponent('.js-react-Table', Table)
  initComponent('.js-react-NavigationSelect', NavigationSelect)
  initComponent('.js-react-AccessAssetsStatus', AccessAssetsStatus)
  initComponent('.js-react-CloudCoreCapacityReport', CloudCoreCapacityReport)
  initComponent('.js-react-CloudCoreConfigurationReport', CloudCoreConfigurationReport)
  initComponent('.js-react-CloudCoreConsumptionReport', CloudCoreConsumptionReport)
  initComponent('.js-react-CloudCoreComplianceReport', CloudCoreComplianceReport)
  initComponent('.js-react-CloudCoreSoftwareReport', CloudCoreSoftwareReport)
  initComponent('.js-react-CloudCoreSoftwareApplicationsReport', CloudCoreSoftwareApplicationsReport)
  initComponent('.js-react-CloudCoreSoftwareOperatingSystemsReport', CloudCoreSoftwareOperatingSystemsReport)
  initComponent('.js-react-CloudCoreSoftwareDatacentersReport', CloudCoreSoftwareDatacentersReport)
  initComponent('.js-react-CloudCoreSoftwareTerminalServersReport', CloudCoreSoftwareTerminalServersReport)
  initComponent('.js-react-CloudianCapacityReport', CloudianCapacityReport)
  initComponent('.js-react-SolidfireCapacityReport', SolidfireCapacityReport)
  initComponent('.js-react-NebulonCapacityReport', NebulonCapacityReport)
  initComponent('.js-react-SystemsSummary', SystemsSummary)
  initComponent('.js-react-APIAuth', APIAuth)
  initComponent('.js-react-DataProtectionConsumptionReport', DataProtectionConsumptionReport)
  initComponent('.js-react-AssetTypesTable', AssetTypesTable)
  initComponent('.js-react-PhysicalAssetsTable', PhysicalAssetsTable)
  initComponent('.js-react-SitesTable', SitesTable)
  initComponent('.js-react-PopupForm', PopupForm)
  initComponent('.js-react-VmSplaReport', VmSplaReport)
  initComponent('.js-react-VmSplaEditor', VmSplaEditor)
  initComponent('.js-react-VDCConsumptionReport', VDCConsumptionReport)
  initComponent('.js-react-SPLAScopeReport', SPLAScopeReport)
  initComponent('.js-react-ImportCSV', ImportCSV)
  initComponent('.js-react-vCentersTable', vCentersTable)
  initComponent('.js-react-OnPremiseCoverage', OnPremiseCoverage)
  initComponent('.js-react-LogicmonitorAssets', LogicmonitorAssets)
  initComponent('.js-react-VulnerabilityGlobe', VulnerabilityGlobe)
  initComponent('.js-react-IPAssetVulnerabilitiesTable', IPAssetVulnerabilitiesTable)
  initComponent('.js-react-IPAssetCertsTable', IPAssetCertsTable)
  initComponent('.js-react-IPAssetExternalTable', IPAssetExternalTable)
  initComponent('.js-react-MonitoringTypes', MonitoringTypes)
  initComponent('.js-react-ImportConfigurations', ImportConfigurations)
})
